module.exports = __webpack_public_path__ + "media/trail/icons-controls-nearby-afcf0592.svg";